import CPIDetails from './CPIDetails'

export default CPIDetails
